export default __webpack_public_path__ + "70d95c8d3bee4c6b2b0e1f80ceb4aa76.png";